const getDashboardList = ({ token }, { observer, biRepo }) => {
  biRepo.getDashboardList(
    { token },
    {
      success: (response) => {
        if (response.getDashboardList.error) {
          observer.failure()
          return
        }
        observer.success(response.getDashboardList.data)
      },
      failure: (e) => {
        observer.failure(e)
      }
    }
  )
}

export default getDashboardList
